import React from "react";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { i18n } from "../../translate/i18n";
import { useGuide } from "../../context/Guide/GuideContext";

const GuideOpenButton = ({ id, title, to, startId }) => {
  const { openGuide } = useGuide();
  const label = i18n.t("gettingStarted.guide");
  return (
    <Tooltip title={label}>
      <Button
        size="small"
        variant="outlined"
        color="primary"
        aria-label={label}
        style={{ borderRadius: 999, minWidth: 0, padding: "4px 10px" }}
        onClick={() => openGuide({ id, title, to, startId })}
      >
        <HelpOutlineIcon fontSize="small" />
      </Button>
    </Tooltip>
  );
};

export default GuideOpenButton;
